module.exports = __webpack_public_path__ + "static/media/image.ec00bce7.svg";